import { useSelector } from "react-redux";
import { Container } from "semantic-ui-react";
import ListaEstudios from "../../Shared/components/ListaEstudios/ListaEstudios";

import "./Validacion.scss";

const Validacion = () => {
	const user_id = parseInt(
		useSelector((state) => state.auth.id),
		10
	);
	return (
		<Container>
			<div className="header">Estudios - Validación</div>
			<div className="captura">
				<ListaEstudios status="2" user_id={user_id} />
			</div>
		</Container>
	);
};

export default Validacion;
